import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetData } from "../../../hooks/useGetData";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";
import { useDeleteData } from "../../../hooks/useDeleteData";
import notify from "../../../components/notify";

export const addNewUser = createAsyncThunk(
  "/usersSlice/addNewUser",
  async ({ data, rejectWithValue }) => {
    try {
      const response = await useInsertData(`v1/users`, data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const addNewUserFormData = createAsyncThunk(
  "/usersSlice/addNewUserFormData",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await useInsertData(`v1/users`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);

export const login = createAsyncThunk(
  "/usersSlice/login",
  async ({ data, rejectWithValue }) => {
    try {
      const response = await useInsertData(`v1/users/login`, data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);


export const getOneUser = createAsyncThunk(
  "/usersSlice/getOneUser",
  async ({ id, rejectWithValue }) => {
    try {
      const response = await useGetData(`v1/users/${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const getUserByType = createAsyncThunk(
  "/usersSlice/getUserByType",
  async ({ type, rejectWithValue }) => {
    try {
      const response = await useGetData(`v1/users?type=${type}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);


export const EditUserFormData = createAsyncThunk(
  "/usersSlice/EditUserFormData",
  async ({id,formData}, { rejectWithValue }) => {
    try {
      const response = await useUpdateData(`v1/users/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const editUser = createAsyncThunk(
  "/usersSlice/editUser",
  async ({id,data}, { rejectWithValue }) => {
    try {
      const response = await useUpdateData(`v1/users/${id}`,data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);


export const blockUser = createAsyncThunk(
  "/usersSlice/blockUser",
  async ({id, data, rejectWithValue }) => {
    try {
      const response = await useUpdateData(`v1/users/userDisable/${id}`, data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const forgetpassword = createAsyncThunk(
  "/usersSlice/forgetpassword",
  async ({ data, rejectWithValue }) => {
    try {
      const response = await useInsertData(`v1/users/forgetpassword`, data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const changepassword = createAsyncThunk(
  "/usersSlice/changepassword",
  async ({ data,id, rejectWithValue }) => {
    try {
      const response = await useUpdateData(`v1/users/changepassword/${id}`, data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);